import { render, staticRenderFns } from "./PdfResidences.vue?vue&type=template&id=4c7bd45b&scoped=true&"
import script from "./PdfResidences.vue?vue&type=script&lang=js&"
export * from "./PdfResidences.vue?vue&type=script&lang=js&"
import style0 from "./PdfResidences.vue?vue&type=style&index=0&id=4c7bd45b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7bd45b",
  null
  
)

export default component.exports